import { Identified } from "@/types/sdk-types";
import { useQuery } from "@tanstack/react-query";
import {
  PrescriptionFormControllerApi,
  PrescriptionForm,
} from "../../../../services";
import { getConfigObject, useBaseContent } from "../../../../utils/utils";

interface Params {
  prescriptionFormId: string;
  xTENANTID?: string;
  enabled?: boolean;
}

export const useGetPrescriptionFormById = ({
  prescriptionFormId,
  xTENANTID,
  enabled = true,
}: Params): useBaseContent<Identified<PrescriptionForm>> =>
  useQuery({
    queryKey: ["get-prescription-form-by-id", prescriptionFormId, xTENANTID],
    queryFn: async () =>
      new PrescriptionFormControllerApi(getConfigObject())
        .getPrescriptionFormById(prescriptionFormId, xTENANTID)
        .then((it) => it?.data),
    enabled: enabled && !!prescriptionFormId,
  });
